import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";
import { SharedStatus } from "./index";

interface StyledBadgeProps {
  status: SharedStatus;
}

interface BadgeTextProps {
  status: SharedStatus;
}

const getStatusColors = (status: SharedStatus) => {
  switch (status) {
    case SharedStatus.NOT_SHARED:
      return {
        background: colors.gray100,
        text: colors.gray600,
        border: colors.gray200,
      };
    case SharedStatus.PARTIALLY_SHARED:
      return {
        background: "#FEF3C7",
        text: "#D97706",
        border: "#FDE68A",
      };
    case SharedStatus.FULLY_SHARED:
      return {
        background: "#ECFDF5",
        text: "#059669",
        border: "#A7F3D0",
      };
    default:
      return {
        background: colors.gray100,
        text: colors.gray600,
        border: colors.gray200,
      };
  }
};

export const StyledBadge = styled("div")<StyledBadgeProps>(({ status }) => {
  const statusColors = getStatusColors(status);

  return {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Manrope",
    fontWeight: 500,
    textAlign: "center",
    whiteSpace: "nowrap",
    userSelect: "none",
    transition: "all 0.2s ease-in-out",
    marginRight: "16px",

    padding: "4px 12px",
    fontSize: "14px",
    lineHeight: "20px",
    borderRadius: "16px",

    backgroundColor: statusColors.background,
    border: `1px solid ${statusColors.border}`,
  };
});

export const BadgeText = styled("span")<BadgeTextProps>(({ status }) => {
  const statusColors = getStatusColors(status);

  return {
    color: statusColors.text,
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: "inherit",
  };
});
